import { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Nav, NavItem, NavPage } from '@monorepo/base/src/components/nav/nav';
import { Page } from '@monorepo/base/src/components/page/page';
import { useRoute } from '../../../modules/hooks/tools/use-route';
import routes from '../../../modules/routes/index.routes';
import { route } from '@monorepo/tools/src/lib/types/url';
import styles from './test-view.module.scss';
import { useNavigateParams } from '@monorepo/tools/src/lib/hooks/tools/use-navigate-params';
import { useNestedSidebar } from '@monorepo/controlled/src/hooks/use-nested-sidebar';

export const TestView = () => {
	const { testId } = useParams();
	const navigate = useNavigateParams();
	const { currentRoute } = useRoute();
	useNestedSidebar();

	if (!testId) {
		navigate(`${routes.tests.index()}`, { replace: true });
		return null;
	}

	const [activeRoute, setActiveRoute] = useState<route>(currentRoute);
	useEffect(() => {
		setActiveRoute(currentRoute);
	}, [currentRoute]);

	return (
		<NavPage>
			<Nav classes={{ nav: styles.nav }} onNavClick={({ to }) => to && setActiveRoute(to)} activeRoute={activeRoute}>
				<NavItem to={testId ? routes.tests.view(testId) : ''}>Overview</NavItem>
				<NavItem to={testId ? routes.tests.creatives(testId) : ''}>Creatives</NavItem>
			</Nav>
			<Page>
				<Outlet />
			</Page>
		</NavPage>
	);
};
